document.addEventListener('DOMContentLoaded', () => {
    
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasFinePointer = window.matchMedia('(pointer: fine)').matches;

    // --- Native scrolling + smooth in-page anchor links ---
    // The wheel/trackpad now scrolls natively (instant, 1:1, no library, no lag).
    // Only clicking an in-page anchor (href="#section") glides smoothly to it,
    // offset so the fixed header doesn't cover the target.
    const HEADER_OFFSET = 110; // approx fixed header + utility bar height
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        const hash = link.getAttribute('href');
        if (!hash || hash === '#') return; // skip placeholder "#" links
        link.addEventListener('click', (e) => {
            const target = document.querySelector(hash);
            if (!target) return;
            e.preventDefault();
            const top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
            window.scrollTo({
                top,
                behavior: prefersReducedMotion ? 'auto' : 'smooth'
            });
        });
    });

    // --- Fancy Magnetic Cursor with hover labels ---
    // A smooth lagging dot + outer ring. The ring grows and shows a label
    // (e.g. VIEW / BOOK) when hovering elements that carry a data-cursor value.
    // The dot also gets a gentle magnetic pull toward buttons & links.
    // Gated to fine pointers (real mouse) and respects reduced-motion.
    const cursorDot   = document.getElementById('cursor');
    const cursorRing  = document.getElementById('cursor-ring');
    const cursorLabel = document.getElementById('cursor-label');

    if (cursorDot && cursorRing && hasFinePointer && !prefersReducedMotion) {
        // Reveal custom cursor only once script is alive, so `cursor: none`
        // never leaves the user with nothing on screen.
        document.documentElement.classList.add('cursor-ready');

        // Tag the known teal/dark sections so the cursor can flip to white
        // over them (and stay teal over the light cream/ivory sections).
        const DARK_SELECTOR = 'header, .hv-utility, .hero, .hv-testimonials, footer';
        document.querySelectorAll(DARK_SELECTOR).forEach(el => el.classList.add('is-dark-section'));

        let mouseX = window.innerWidth / 2,  mouseY = window.innerHeight / 2;
        let dotX   = mouseX, dotY   = mouseY;   // dot follows quickly
        let ringX  = mouseX, ringY  = mouseY;   // ring lags behind for premium feel
        let magnetX = 0, magnetY = 0;           // magnetic offset toward hovered target
        let seeded = false;

        let onDark = false;
        document.addEventListener('mousemove', (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            if (!seeded) {
                dotX = ringX = mouseX; dotY = ringY = mouseY;
                cursorDot.style.opacity = cursorRing.style.opacity = '1';
                seeded = true;
            }

            // Adaptive colour: white over teal/dark sections, teal over light.
            const el = e.target;
            const nowDark = !!(el && el.closest && el.closest('.is-dark-section'));
            if (nowDark !== onDark) {
                onDark = nowDark;
                cursorDot.classList.toggle('on-dark', onDark);
                cursorRing.classList.toggle('on-dark', onDark);
            }
        });

        // Hide on leave / show on return so it never strands offscreen.
        document.addEventListener('mouseleave', () => {
            cursorDot.style.opacity = cursorRing.style.opacity = '0';
        });
        document.addEventListener('mouseenter', () => {
            cursorDot.style.opacity = cursorRing.style.opacity = '1';
        });

        function renderCursor() {
            // Lower factors = smoother, softer trailing motion.
            // Dot leads, ring follows more gently for the premium lag effect.
            dotX  += (mouseX + magnetX - dotX)  * 0.22;
            dotY  += (mouseY + magnetY - dotY)  * 0.22;
            ringX += (mouseX + magnetX - ringX) * 0.10;
            ringY += (mouseY + magnetY - ringY) * 0.10;

            cursorDot.style.transform  = `translate3d(${dotX}px, ${dotY}px, 0) translate(-50%, -50%)`;
            cursorRing.style.transform = `translate3d(${ringX}px, ${ringY}px, 0) translate(-50%, -50%)`;
            requestAnimationFrame(renderCursor);
        }
        requestAnimationFrame(renderCursor);

        // Targets that influence the cursor. Anything with a data-cursor attr
        // gets a label; plain links/buttons just grow the ring.
        const interactive = document.querySelectorAll('a, button, .hover-target, [data-cursor]');

        interactive.forEach(el => {
            const label = el.getAttribute('data-cursor');

            el.addEventListener('mouseenter', () => {
                cursorRing.classList.add('active');
                if (label) {
                    cursorLabel.textContent = label;
                    cursorRing.classList.add('labelled');
                }
            });

            el.addEventListener('mouseleave', () => {
                cursorRing.classList.remove('active', 'labelled');
                cursorLabel.textContent = '';
            });
        });
    }

    // --- Header Scroll Effect ---
    const header = document.getElementById('header');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    // --- GSAP Animations ---
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);

        // Custom Text Splitter for Hero (Simulates GSAP SplitText)
        const heroTitle = document.querySelector('.hero-text h1');
        if (heroTitle) {
            const htmlText = heroTitle.innerHTML;
            // A crude but effective way to split by spaces while preserving HTML tags inside.
            // For a perfect split, we wrap the whole thing or specific spans in overflow:hidden divs.
            // We'll just animate the whole h1 first, then the span.
        }

        // Hero Animations
        const tl = gsap.timeline();
        
        tl.fromTo('.gsap-hero-text > *', 
            { y: 80, opacity: 0, rotationX: 20 },
            { y: 0, opacity: 1, rotationX: 0, duration: 1.5, stagger: 0.2, ease: "expo.out", delay: 0.2 }
        );

        tl.fromTo('.gsap-hero-img img',
            { scale: 1.2, opacity: 0, filter: 'grayscale(100%) blur(10px)' },
            { scale: 1, opacity: 1, filter: 'grayscale(20%) blur(0px)', duration: 2, ease: "expo.out" },
            "-=1.5"
        );

        tl.fromTo('.hero-glass-card',
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, duration: 1.5, ease: "elastic.out(1, 0.5)" },
            "-=1"
        );

        // Parallax Blobs
        gsap.to('.blob-1', {
            yPercent: 100,
            rotation: 45,
            ease: "none",
            scrollTrigger: {
                trigger: ".hero",
                start: "top top",
                end: "bottom top",
                scrub: 1 // smooth scrubbing
            }
        });

        gsap.to('.blob-2', {
            yPercent: -100,
            rotation: -45,
            ease: "none",
            scrollTrigger: {
                trigger: ".hero",
                start: "top top",
                end: "bottom top",
                scrub: 1
            }
        });

        // Scroll Reveal Animations with smooth clipping
        gsap.utils.toArray('.gsap-fade-up').forEach(element => {
            gsap.fromTo(element, 
                { y: 100, opacity: 0 },
                {
                    y: 0, opacity: 1, duration: 1.5, ease: "expo.out",
                    scrollTrigger: { trigger: element, start: "top 85%" }
                }
            );
        });

        gsap.utils.toArray('.gsap-fade-right').forEach(element => {
            gsap.fromTo(element, 
                { x: -100, opacity: 0 },
                {
                    x: 0, opacity: 1, duration: 1.5, ease: "expo.out",
                    scrollTrigger: { trigger: element, start: "top 85%" }
                }
            );
        });

        gsap.utils.toArray('.gsap-fade-left').forEach(element => {
            gsap.fromTo(element, 
                { x: 100, opacity: 0 },
                {
                    x: 0, opacity: 1, duration: 1.5, ease: "expo.out",
                    scrollTrigger: { trigger: element, start: "top 85%" }
                }
            );
        });

        // Staggered Service Cards & Value Cards
        const staggerContainers = document.querySelectorAll('.services-layout, .hv-values-grid');
        staggerContainers.forEach(container => {
            const cards = container.querySelectorAll('.gsap-stagger');
            if (cards.length > 0) {
                gsap.fromTo(cards,
                    { y: 60, opacity: 0, scale: 0.96 },
                    {
                        y: 0, opacity: 1, scale: 1, duration: 1.1, stagger: 0.12, ease: "power3.out",
                        scrollTrigger: { trigger: container, start: "top 82%" }
                    }
                );
            }
        });
        // --- Counter Animation ---
        const counters = document.querySelectorAll('.stat-number');
        if (counters.length > 0) {
            counters.forEach(counter => {
                const target = parseFloat(counter.getAttribute('data-target'));
                const suffix = counter.getAttribute('data-suffix') || '';
                const decimals = parseInt(counter.getAttribute('data-decimals')) || 0;
                
                ScrollTrigger.create({
                    trigger: counter,
                    start: "top 90%",
                    once: true,
                    onEnter: () => {
                        gsap.to(counter, {
                            innerHTML: target,
                            duration: 2.5,
                            ease: "power3.out",
                            snap: { innerHTML: Math.pow(10, -decimals) }, // Snap to correct decimal places
                            onUpdate: function() {
                                // Add suffix back and format if needed
                                let currentVal = parseFloat(this.targets()[0].innerHTML).toFixed(decimals);
                                this.targets()[0].innerHTML = currentVal + suffix;
                            }
                        });
                    }
                });
            });
        }
    }

    // --- Form Submission Demo ---
    const contactForm = document.getElementById('contactForm');
    const formStatus = document.getElementById('formStatus');

    if (contactForm && formStatus) {
        contactForm.addEventListener('submit', (e) => {
            e.preventDefault();
            
            // GSAP hide and show
            gsap.to(contactForm, {
                opacity: 0, y: -20, duration: 0.5, onComplete: () => {
                    contactForm.style.display = 'none';
                    formStatus.style.display = 'block';
                    gsap.fromTo(formStatus, {opacity: 0, y: 20}, {opacity: 1, y: 0, duration: 0.5});
                }
            });
        });
    }
});

// Appointo styling (green-to-teal) and timezone hiding are handled cleanly via pure CSS in appointo-checkout-enhancer.liquid for optimal 60fps performance without layout thrashing.

/* ── Rewards page: scroll-reveal for .gsap-fade-up elements ── */
(function () {
    const fadeEls = document.querySelectorAll('.gsap-fade-up');
    if (!fadeEls.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
            if (!entry.isIntersecting) return;
            // Stagger siblings in same parent
            const siblings = entry.target.parentElement.querySelectorAll('.gsap-fade-up');
            let delay = 0;
            siblings.forEach((sib, idx) => { if (sib === entry.target) delay = idx * 80; });
            setTimeout(() => entry.target.classList.add('in-view'), delay);
            observer.unobserve(entry.target);
        });
    }, { threshold: 0.12 });
    fadeEls.forEach(el => observer.observe(el));
})();
